import { createVanIconComponent } from "./van"

const SmileOutlined = createVanIconComponent("smile-o")
export default SmileOutlined
